import React from "react";
// Blank page to fix bug with redirect from Azure Login external window
function Redirect() {
  return <div />;
}

export default Redirect;
